import React from 'react';
import { Box, Stack, styled, Typography, useTheme } from '@mui/material';

import Icon from '@/components/icons/Icon';

const CareerCardContainer = styled('article')`
  display: flex;
  background-color: #fff;
  border-radius: 1rem;
  box-shadow: 2px 2px 15px 0px #00000026;
  padding: 1.5rem 1.875rem 1.75rem;
  position: relative;
  overflow: hidden;
  height: min-content;
  min-height: 180px;
  min-width: 450px;

  &::before {
    content: '""';
    width: 506px;
    height: 506px;
    border-radius: 50%;
    background-color: #f3f4f8;
    z-index: 0;
    

    position: absolute;
    top: 0px;
    left 0px;

    transform: translate(-206px, -214px);
  }

  &::after {
    content: '""';
    width: 116px;
    height: 116px;
    border-radius: 50%;
    background-color: #d4dfe8;
    z-index: 0;

    position: absolute;
    top: 0px;
    left: 0px;

    transform: translate(-11px, -19px);
  }
`;

function CareerCard({
  key,
  link,
  title,
  category,
  location,
}: {
  key?: string;
  link: string;
  title: string;
  category: string;
  location: string;
}) {
  const theme = useTheme();

  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      <CareerCardContainer>
        <Stack
          sx={{
            gap: { xs: 3, md: 4 },
            zIndex: 1,
            height: 'auto',
            justifyContent: 'space-between',
          }}
        >
          <Stack
            sx={{
              flexDirection: 'row',
              gap: 4,
              marginLeft: '-4px',
              marginTop: '-5px',
              borderWidth: '1px solid black',
            }}
          >
            <Icon
              iconName="coach-v2"
              style={{
                width: '43px',
                height: '43px',
                color: '#606E92',
              }}
            />

            <Stack
              sx={{
                flex: 1,
                marginTop: theme.spacing(1.25),
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  color: '#52545F',
                  fontSize: {
                    xs: '1.25rem !important',
                    sm: '1.4375rem !important',
                  },
                  lineHeight: '1.4 !important',
                  fontWeight: 700,
                  whiteSpace: 'pre-wrap',
                  verticalAlign: 'bottom',
                }}
              >
                {title}
              </Typography>
            </Stack>
          </Stack>

          <Stack>
            <Typography
              variant="body2"
              sx={{
                color: '#52545F',
                fontSize: '1.125rem !important',
                lineHeight: '1.46 !important',
                whiteSpace: 'pre-wrap',
              }}
            >
              {category}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#52545F',
                fontSize: '1.125rem !important',
                lineHeight: '1.46 !important',
                whiteSpace: 'pre-wrap',
              }}
            >
              {location}
            </Typography>
          </Stack>
        </Stack>
      </CareerCardContainer>
    </a>
  );
}

export default CareerCard;
